/**
 * Links to Penny Meals (pennymeals.com), DealHawk's sister app that turns grocery
 * markdowns into cheap dinners. Plain followed links: they exist to send readers and
 * search authority to pennymeals.com. Pure data so the pre-renderer can use it too.
 */
export const PENNY_MEALS_URL = "https://pennymeals.com/grocery-deals";
export const PENNY_MEALS_FOOTER_LABEL = "Penny Meals: cheap dinners from grocery markdowns";

export const pennyMealsUrl = (path = "") => `${PENNY_MEALS_URL}${path}`;
